// extracted by mini-css-extract-plugin
export default {"container":"buWFKk","active":"bypNIa","placeholder-shimmer":"Phlu8o","placeholderShimmer":"Phlu8o","universal":"RQg5EO","dark":"fgtxAC","light":"_kUe9r"};